import { actualSite, BRAND_NAMES } from "@/app/utils/utils";

export type NavigationMenuItem = {
  name: string;
  link?: string;
  src?: string;
  target?: string;
  /** Abre o modal SAC em vez de navegar */
  openSacModal?: boolean;
  /** Abre o painel de preferências de cookies da BeCompliance */
  openCookiePreferences?: boolean;
};

export interface LinksNavigation {
  name: string;
  src: string;
  link?: string;
  groups?: {
    name: string;
    itens: NavigationMenuItem[];
  }[];
}

const { siteDefaultName } = actualSite();

export const NavigationLines: LinksNavigation[] = [
  {
    name: "Novos",
    src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/novos.webp",
    groups: [
      {
        name: "Passeio",
        itens: [
          {
            name: "Corolla",
            src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/Corolla_Altis.png",
            link: "/corolla",
          },
        ],
      },
      {
        name: "SUVs",
        itens: [
          {
            name: "Yaris Cross",
            src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/Yaris_Cross.png",
            link: "/yaris-cross",
          },
          {
            name: "Corolla Cross",
            src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/Corolla_Cross.png",
            link: "/corolla-cross",
          },
          {
            name: "RAV4",
            src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/RAV4.png",
            link: "/rav4",
          },
          {
            name: "SW4",
            src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/sw4_diamond.png",
            link: "/sw4",
          },
        ],
      },
      {
        name: "Esportivos",
        itens: [
          {
            name: "Corolla Hatch GR-Sport",
            src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/GR-Sport_Corolla_HB.png",
            link: "/corolla-hatch",
          },
          {
            name: "Corolla GR-Sport",
            src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/GR-Sport_Corolla.png",
            link: "/corolla?model=Esportivo",
          },
          {
            name: "Corolla Cross GR-Sport",
            src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/GR-Sport_Corolla_Cross.png",
            link: "/corolla-cross?model=Esportivo",
          },
          {
            name: "Hilux GR-Sport",
            src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/GR-Sport%20_HILUX.png",
            link: "/hilux?model=Esportivo",
          },
        ],
      },
      {
        name: "Híbridos",
        itens: [
          {
            name: "Corolla Híbrido",
            src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/Corolla_Altis_H%C3%ADbrido.png",
            link: "/corolla?model=Híbrido",
          },
          {
            name: "RAV4",
            src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/RAV4.png",
            link: "/rav4?model=Híbrido",
          },
          {
            name: "Corolla Cross Híbrido",
            src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/Corolla_Cross.png",
            link: "/corolla-cross?model=Híbrido",
          },
          {
            name: "Yaris Cross",
            src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/Yaris_Cross.png",
            link: "/yaris-cross?model=Híbrido",
          },
        ],
      },
      {
        name: "Elétricos",
        itens: [
          {
            name: "bZ4X",
            src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/bZ4X.png",
            link: "/bz4x",
          },
        ],
      },
      {
        name: "Pick-ups",
        itens: [
          {
            name: "Hilux Cabine Dupla",
            src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/mbl/HILUX_Conquest.png",
            link: "/hilux",
          },
        ],
      },
      {
        name: "Comercial",
        itens: [
          {
            name: "Hiace",
            src: "https://bloblandingpageprd.blob.core.windows.net/toyota/geral/hiace/hiace.png",
            link: "/hiace",
          },
        ],
      },
    ],
  },
  {
    name: "Seminovos",
    src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/seminovos.webp",
    groups: [
      {
        name: "Seminovos",
        itens: [
          {
            name: "Seminovos Certificados",
            link: `https://www.${BRAND_NAMES.LOWERCASE_PLAIN}seminovos.com.br/veiculos?certificado=true&ano=2018,2025&preco=4390000,42499000&km=101,81193&entrada=12749700&ordenacao=1`,
            target: "_blank",
          },
        ],
      },
      {
        name: "Site Seminovos",
        itens: [
          {
            name: "Ver estoque completo",
            link: `https://www.${BRAND_NAMES.LOWERCASE_PLAIN}seminovos.com.br`,
            target: "_blank",
          },
        ],
      },
    ],
  },
  {
    name: "Ofertas",
    src: "",
    link: "/ofertas",
  },
  {
    name: "Vendas Diretas",
    src: "https://bloblandingpageprd.blob.core.windows.net/toyota/geral/menu-venda.png",
    groups: [
      {
        name: "",
        itens: [
          {
            name: "Frotista",
            link: "/venda-direta/frotista",
          },
          {
            name: "CNPJ",
            link: "/venda-direta/cnpj",
          },
          {
            name: "Pessoa com Deficiência",
            link: "/venda-direta/pessoa-com-deficiencia",
          },
          {
            name: "Produtor Rural",
            link: "/venda-direta/produtor-rural",
          },
          {
            name: "Taxista",
            link: "/venda-direta/taxista",
          },
          {
            name: "Governo",
            link: "/venda-direta/governo",
          },
          {
            name: "Move Brasil",
            link: "/move-brasil",
          },
        ],
      },
    ],
  },
  {
    name: "Serviços",
    src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/servicos.webp",
    groups: [
      {
        name: "Serviços",
        itens: [
          {
            name: "Pós-Vendas",
            link: "/servicos/pos-venda",
          },
          {
            name: "Garantia Toyota",
            link: "/garantiatoyota",
          },
          {
            name: "Agendamento",
            link: "/servicos/agendamento",
          },
          {
            name: "Blindagem",
            link: "/servicos/blindagem",
          },
          {
            name: "Peças",
            link: "/servicos/pecas",
          },
        ],
      },
      {
        name: "Financiamento",
        itens: [
          {
            name: "Ciclo Toyota",
            link: "/servicos/ciclo-toyota",
          },
          {
            name: "Consórcio",
            link: "/servicos/consorcio",
          },
          /*{
            name: "Acessórios",
            link: "/servicos/acessorios",
          },*/
        ],
      },
    ],
  },
  {
    name: "Sobre",
    src: "https://sablobsitestoyotaprd.blob.core.windows.net/images/Shared/Header/toyota_sobre.webp",
    groups: [
      {
        name: `Sobre a ${BRAND_NAMES.DEFAULT}`,
        itens: [
          {
            name: "História e Demonstrativos",
            link: "/sobre",
          },
          {
            name: "Trabalhe Conosco",
            link: "https://grupoaguiabranca.empregare.com/pt-br",
            target: "_blank",
          },
          {
            name: "Canal Compliance",
            link: "https://www.contatoseguro.com.br/compliancecomercio",
            target: "_blank",
          },
          {
            name: "Portal de Privacidade",
            link: "https://privacidadecomercio.aguiabranca.com.br",
            target: "_blank",
          },
          {
            name: "Política de Cookies",
            link: "/cookies",
          },
          {
            name: "Mostrar preferências de cookie",
            openCookiePreferences: true,
          },
          // {
          //   name: "Relato Estratégico ESG",
          //   link: "https://osakaveiculos.com.br/ESG2324",
          //   target: "_blank",
          // },
        ],
      },
      {
        name: "SAC",
        itens: [
          {
            name: "Entrar em contato",
            openSacModal: true,
          },
        ],
      },
    ],
  },
];
